// TOP LEVEL IMPORTS
import React from 'react';
// MODULES
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

// CONSTSANTS & DESTRUCTURING
// ========================================
const FONT_SIZE = 19;

// EXPORTED COMPONENT
// ========================================
const SubtotalArea = ({ invoice, currencySymbol }) => (
  <div>
    <h3 style={{ textAlign: 'right', margin: 0 }}>
      <span style={{ fontSize: FONT_SIZE - 5 }}>packaging:</span>
      <span style={{ fontSize: FONT_SIZE - 5 }}>
        {' '}
        {CurrencyHelpers.centsToDollars(invoice.subtotal, { symbol: currencySymbol })}
      </span>
    </h3>
    <h3 style={{ textAlign: 'right', margin: 0 }}>
      <span style={{ fontSize: FONT_SIZE - 5 }}>discount:</span>
      <span style={{ fontSize: FONT_SIZE - 5 }}>
        {' '}
        {`- ${CurrencyHelpers.centsToDollars(invoice.discountAmount, { symbol: currencySymbol })}`}
      </span>
    </h3>
    <h3 style={{ textAlign: 'right', margin: 0 }}>
      <span style={{ fontSize: FONT_SIZE - 5 }}>subtotal:</span>
      <span style={{ fontSize: FONT_SIZE - 5 }}>
        {' '}
        {CurrencyHelpers.centsToDollars(invoice.subtotalAfterDiscount, { symbol: currencySymbol })}
      </span>
    </h3>
    <h3 style={{ textAlign: 'right', margin: 0 }}>
      <span style={{ fontSize: FONT_SIZE - 5 }}>sales tax:</span>
      <span style={{ fontSize: FONT_SIZE - 5 }}>
        {' '}
        {CurrencyHelpers.centsToDollars(invoice.taxAmount, { symbol: currencySymbol })}
      </span>
    </h3>
    <div style={{ float: 'right', borderTop: '2px solid #efefef', width: 200 }} />
    <div style={{ height: 10 }} />
    {/* <div style={{ height: 10 }} /> is a weird trick to clear the float so that subtotalAfterTax shows to the right */}
    <div style={{ textAlign: 'right', marginBottom: 0 }}>
      <h3>
        <span style={{ fontSize: FONT_SIZE }}>Final Package Price:</span>
        <span className="money-green" style={{ fontSize: FONT_SIZE + 8 }}>
          {' '}
          {CurrencyHelpers.centsToDollars(invoice.subtotalAfterTax, { symbol: currencySymbol })}
        </span>
      </h3>
    </div>
  </div>
);

// EXPORT
// ========================================
export default SubtotalArea;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/CreateStep/SubtotalArea/index.js